module.exports = __webpack_public_path__ + "static/media/smiley3.57ca60a0.png";